package app

import kotlinx.serialization.Serializable

@Serializable
data class AppProperties(var apiEndpoint: String = "", var mapsKey : String = "")
